module.exports = __webpack_public_path__ + "img/refresh.055b312a.svg";